<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import LeadAPI from 'dashboard/api/leads';

const props = defineProps({
  contactId: {
    type: [Number, String],
    required: true,
  },
});

const { t } = useI18n();
const lead = ref(null);
const isLoading = ref(false);

const stageLabel = computed(() =>
  lead.value ? t(`LEADS.STAGES.${lead.value.stage}`) : ''
);

const fetchLead = async () => {
  if (!props.contactId) return;
  isLoading.value = true;
  try {
    const {
      data: { payload },
    } = await LeadAPI.get({ contact_id: props.contactId });
    [lead.value] = payload;
  } finally {
    isLoading.value = false;
  }
};

watch(() => props.contactId, fetchLead);
onMounted(fetchLead);
</script>

<template>
  <div
    v-if="lead"
    class="flex items-center justify-between px-4 py-2 mb-2 rounded-md bg-n-solid-2 border border-n-weak"
  >
    <div class="flex items-center gap-2 text-xs">
      <span class="text-n-slate-10">{{ t('LEADS.STAGE.LABEL') }}:</span>
      <span class="font-medium text-n-slate-12">{{ stageLabel }}</span>
    </div>
    <router-link
      :to="{ name: 'leads_dashboard_show', params: { leadId: lead.id } }"
      class="text-xs text-n-blue-9 hover:underline"
    >
      {{ t('LEADS.VIEW') }}
    </router-link>
  </div>
</template>
